
import React, { useEffect,useMemo } from "react";

import type { StockSituationOwnership } from '@/types/stockSituation'

/* eslint-disable no-unused-vars */
declare global {
  interface Window {
    Highcharts: any;
  }
}
/* eslint-enable no-unused-vars */

type Props = {
  items:StockSituationOwnership[]
}

const ChartComponent: React.FC<Props> = ({ items }) => {
  const data = useMemo(() => {
    if (items.length === 0) return [];
    return [...items[0].ownershipBreakdownList]
      .sort((a, b) => a.sort - b.sort)
      .map(item => ({
        y: item.ratio,
        name: item.name,
      }));
  }, [items]);

  useEffect(() => {
    if (window.Highcharts) {
        const Highcharts = window.Highcharts;

        Highcharts.wrap(Highcharts.seriesTypes.pie.prototype, "drawDataLabels", function (this: any, p: any) {
          const xOffset = 5;
          const yOffset = 12;
          p.call(this);
  
          Highcharts.each(this.points, function (p: any) {
            if (p.dataLabel && p.connector) {
              p.connector.attr({
                d: [
                  "M",
                  p.dataLabel._pos.x + (p.labelPos[6] === "left" ? -xOffset : xOffset),
                  p.dataLabel._pos.y + yOffset,
                  "L",
                  p.labelPos[4],
                  p.labelPos[5],
                ],
              });
            }
          });
        });
  
        Highcharts.chart('container', {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: "pie",
          fontFamily: '"Noto Sans JP",Arial,sans-serif',
      },
      credits: {
          enabled: false,
      },
      title: {
          text: "所有株式数における割合",
          verticalAlign: "top",
          align: "center",
          useHTML: true,
          style: {
            lineHeight: "1.6",
            fontWeight: "700",
          },
      },
      tooltip: {
          enabled: false,
          pointFormat: "{series.name}: {point.percentage:.1f}%",
      },
      plotOptions: {
          pie: {
              allowPointSelect: true,
              cursor: "pointer",
              colors: [
                  "#3783C4", // 1. 金融機関
                  "#569CD8", // 2. 金融機関取引業者
                  "#449330", // 3. その他の法人
                  "#6BA65D", // 4. 外国法人等
                  "#002D65", // 5. 自己株式
                  "#8DBF80", // 6. 個人その他
              ],
              borderWidth: 1,
              size: "57%",
              borderColor: "#efefef",
              dataLabels: {
                  useHTML: true,
                  enabled: true,
                  color: "#222",
                  connectorWidth: 2,
                  distance: 20,
                  connectorColor: "#999999",
                  format: "{point.name}:<br> {point.percentage:.2f} %",
                  style: {
                      fontSize: "10px;",
                      fontWeight: "normal",
                  },
              },
          },
      },
      series: [
          {
              name: "",
              colorByPoint: true,
              data
          },
      ],
    });
    }
  }, [data]);

  return <div style={{ width: "100%", overflowX: "auto" }}>
    <div id="container" style={{ minWidth: "600px", width: "100%" }} />
  </div>;
};

export default ChartComponent;
